import image0_de from "./de/screen_0.jpg";
import image1_de from "./de/screen_1.jpg";
import image2_de from "./de/screen_2.jpg";
import image3_de from "./de/screen_3.jpg";
import image4_de from "./de/screen_4.jpg";
import image5_de from "./de/screen_5.jpg";

import image0_en from "./en/screen_0.jpg";
import image1_en from "./en/screen_1.jpg";
import image2_en from "./en/screen_2.jpg";
import image3_en from "./en/screen_3.jpg";
import image4_en from "./en/screen_4.jpg";
import image5_en from "./en/screen_5.jpg";

export default {
  de: [image0_de, image1_de, image2_de, image3_de, image4_de, image5_de],
  en: [image0_en, image1_en, image2_en, image3_en, image4_en, image5_en],
};
